import React from "react";

const DocumentTabBadge = ({ count }) => {
  const n = Number(count || 0);
  if (n <= 0) return null;
  return (
    <span className="document-tab-unread-badge" aria-label={`${n} new`}>
      {n > 99 ? "99+" : n}
    </span>
  );
};

export default DocumentTabBadge;
